import { useCallback, useRef, useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import EntryChannels from './components/EntryChannels';
import NewsFlash from './components/NewsFlash';
import HotRanking from './components/HotRanking';
import HowItWorks from './components/HowItWorks';
import StatsBand from './components/StatsBand';
import Faq from './components/Faq';
import FooterCta from './components/FooterCta';
import SiteFooter from './components/SiteFooter';
import Toast from './components/Toast';

export default function Home() {
  const [toast, setToast] = useState<string | null>(null);
  const timerRef = useRef<number | null>(null);

  const showToast = useCallback((message: string) => {
    if (timerRef.current) {
      window.clearTimeout(timerRef.current);
    }
    setToast(message);
    timerRef.current = window.setTimeout(() => setToast(null), 2400);
  }, []);

  return (
    <div className="min-h-screen bg-background-50 font-body text-foreground-950">
      <Navbar onEnter={showToast} />
      <main>
        <Hero onEnter={showToast} />
        <EntryChannels onEnter={showToast} />
        <NewsFlash />
        <HotRanking onEnter={showToast} />
        <HowItWorks />
        <StatsBand />
        <Faq />
        <FooterCta onEnter={showToast} />
      </main>
      <SiteFooter />
      <Toast message={toast} />
    </div>
  );
}